/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Shared_Countries {
    Denmark = 10,
    Norway = 20,
    Sweden = 30,
    Germany = 40,
    Afghanistan = 50,
    Albania = 60,
    Algeria = 70,
    Andorra = 80,
    Angola = 90,
    AntiguaandBarbuda = 100,
    Argentina = 110,
    Armenia = 120,
    Azerbaijan = 130,
    Australia = 140,
    Bahamas = 150,
    Bahrain = 160,
    Bangladesh = 170,
    Barbados = 180,
    Belarus = 190,
    Belgium = 200,
    Belize = 210,
    Benin = 220,
    Bhutan = 230,
    Bolivia = 240,
    BosniaandHerzegovina = 250,
    Botswana = 260,
    Brazil = 270,
    Brunei = 280,
    Bulgaria = 290,
    BurkinaFaso = 300,
    Burundi = 310,
    Cambodia = 320,
    Cameroon = 330,
    Canada = 340,
    CentralAfricanRepublic = 350,
    Chile = 360,
    Colombia = 370,
    Comoros = 380,
    DemocraticRepublicoftheCongo = 390,
    RepublicoftheCongo = 400,
    CostaRica = 410,
    Cuba = 420,
    Cyprus = 430,
    Djibouti = 440,
    Dominica = 450,
    DominicanRepublic = 460,
    Ecuador = 470,
    Egypt = 480,
    ElSalvador = 490,
    IvoryCoast = 500,
    Eritrea = 510,
    Estonia = 520,
    Swaziland = 530,
    Ethiopia = 540,
    FaroeIslands = 550,
    Fiji = 560,
    Philippines = 570,
    Finland = 580,
    UnitedArabEmirates = 590,
    France = 600,
    Gabon = 610,
    Gambia = 620,
    Georgia = 630,
    Ghana = 640,
    Grenada = 650,
    Greece = 660,
    Greenland = 670,
    Guatemala = 680,
    Guinea = 690,
    GuineaBissau = 700,
    Guyana = 710,
    Haiti = 720,
    Honduras = 730,
    India = 740,
    Indonesia = 750,
    Iraq = 760,
    Iran = 770,
    Ireland = 780,
    Iceland = 790,
    Israel = 800,
    Italy = 810,
    Jamaica = 820,
    Japan = 830,
    Jordan = 840,
    CapeVerde = 850,
    Kazakhstan = 860,
    Kenya = 870,
    China = 880,
    Kyrgyzstan = 890,
    Kiribati = 900,
    Croatia = 910,
    Kuwait = 920,
    Laos = 930,
    Lesotho = 940,
    Latvia = 950,
    Lebanon = 960,
    Liberia = 970,
    Libya = 980,
    Liechtenstein = 990,
    Lithuania = 1000,
    Luxembourg = 1010,
    Madagascar = 1020,
    Malawi = 1030,
    Malaysia = 1040,
    Maldives = 1050,
    Mali = 1060,
    Malta = 1070,
    Morocco = 1080,
    MarshallIslands = 1090,
    Mauritania = 1100,
    Mauritius = 1110,
    Mexico = 1120,
    Micronesia = 1130,
    Moldova = 1140,
    Monaco = 1150,
    Mongolia = 1160,
    Montenegro = 1170,
    Mozambique = 1180,
    Myanmar = 1190,
    Namibia = 1200,
    Nauru = 1210,
    Netherlands = 1220,
    Nepal = 1230,
    NewZealand = 1240,
    Nicaragua = 1250,
    Niger = 1260,
    Nigeria = 1270,
    NorthKorea = 1280,
    Macedonia = 1290,
    Oman = 1300,
    Pakistan = 1310,
    Palau = 1320,
    Panama = 1330,
    PapuaNewGuinea = 1340,
    Paraguay = 1350,
    Peru = 1360,
    Poland = 1370,
    Portugal = 1380,
    Qatar = 1390,
    Romania = 1400,
    Russia = 1410,
    Rwanda = 1420,
    SolomonIslands = 1430,
    Samoa = 1440,
    SanMarino = 1450,
    SaoTomeandPrincipe = 1460,
    SaudiArabia = 1470,
    Switzerland = 1480,
    Senegal = 1490,
    Serbia = 1500,
    Seychelles = 1510,
    SierraLeone = 1520,
    Singapore = 1530,
    SaintKittsandNevis = 1540,
    SaintLucia = 1550,
    SaintVincentandtheGrenadines = 1560,
    Slovakia = 1570,
    Slovenia = 1580,
    Somalia = 1590,
    Spain = 1600,
    SriLanka = 1610,
    UnitedKingdom = 1620,
    Sudan = 1630,
    Suriname = 1640,
    SouthAfrica = 1650,
    SouthKorea = 1660,
    SouthSudan = 1670,
    Syria = 1680,
    Tajikistan = 1690,
    Tanzania = 1700,
    Chad = 1710,
    Thailand = 1720,
    CzechRepublic = 1730,
    Togo = 1740,
    Tonga = 1750,
    TrinidadandTobago = 1760,
    Tunisia = 1770,
    Turkmenistan = 1780,
    Tuvalu = 1790,
    Turkey = 1800,
    Uganda = 1810,
    Ukraine = 1820,
    Hungary = 1830,
    Uruguay = 1840,
    UnitedStates = 1850,
    Uzbekistan = 1860,
    Vanuatu = 1870,
    Vatican = 1880,
    Venezuela = 1890,
    Vietnam = 1900,
    Yemen = 1910,
    Zambia = 1920,
    Zimbabwe = 1930,
    EquatorialGuinea = 1940,
    Austria = 1950,
    EastTimor = 1960,
    HongKong = 1970,
    CaymanIslands = 1980,
    NorthMacedonia = 1990,
    Macau = 2000,
    Yugoslavia = 2010,
    Taiwan = 2020,
}
